if (!customElements.get('oos-alt-form')) {
  const defineOosAltForm = () => {
    const ProductForm = customElements.get('product-form');
    if (!ProductForm || customElements.get('oos-alt-form')) return;
    customElements.define(
      'oos-alt-form',
      class extends ProductForm {}
    );
  };

  if (customElements.get('product-form')) {
    defineOosAltForm();
  } else {
    customElements.whenDefined('product-form').then(defineOosAltForm);
  }
}
